import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger'
import Swiper from 'swiper/bundle'
gsap.registerPlugin(ScrollTrigger)

/**
 * TestimonialsSlider component.
 * @author Dayne Coulson-Hoffacker
 */
export default class TestimonialsSlider {
  /**
   * Constructs a new TestimonialsSlider component.
   * @param {Object} options - Options.
   * @param {HTMLElement} options.element - Container.
   */
  constructor (options) {
    this.element = options.element
    this.swiperContainer = this.element.querySelector('.swiper-container')
    this.swiperPagination = this.element.querySelector('.swiper-pagination')

    var slider = new Swiper(this.swiperContainer, {
      loop: true,
      slidesPerView: 1,
      autoHeight: true,
      autoplay: {
        delay: 3000
      },
      pagination: {
        el: this.swiperPagination,
        clickable: true
      },
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      }
    })

    slider.autoplay.stop()

    ScrollTrigger.create({
      trigger: this.element,
      start: 'top bottom',
      markers: false,
      scroller: 'body',
      onEnter: () => {
        slider.autoplay.start()
      }
    })
  }
}



// WEBPACK FOOTER //
// ./components/section/testimonials/index.js